'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventChartList = exports.EventChart = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _table = require('../../../../../table');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },

  flex: {
    flex: 1
  }
};

var EventChart = exports.EventChart = function EventChart(_ref) {
  var _ref$chart = _ref.chart,
      chart = _ref$chart === undefined ? (0, _immutable.Map)() : _ref$chart,
      _ref$addToChart = _ref.addToChart,
      addToChart = _ref$addToChart === undefined ? function () {
    return null;
  } : _ref$addToChart,
      _ref$selectEvent = _ref.selectEvent,
      selectEvent = _ref$selectEvent === undefined ? function () {
    return null;
  } : _ref$selectEvent;

  var cells = (0, _immutable.List)([_react2.default.createElement(_table.Cell, { row: 1, column: 1 })]);

  cells = cells.concat(chart.get('ages').map(function (age, idx) {
    return _react2.default.createElement(
      _table.Cell,
      {
        row: 1,
        column: idx + 2,
        number: true,
        style: { textAlign: 'center' }
      },
      age
    );
  }));

  var numColumns = cells.count();

  var rowCount = 1;
  chart.get('labels').map(function (label) {
    return label.get('rows').map(function (row, idx) {
      rowCount++;

      if (idx === 0) {
        cells = cells.push(_react2.default.createElement(
          _table.Cell,
          {
            row: rowCount,
            rowSpan: label.get('rows').count(),
            column: 1,
            header: true
          },
          label.get('label')
        ));
      }

      var colCount = 2;
      cells = cells.concat(row.get('events').map(function (event, eventIdx) {

        var span = event.get('span');
        var placeholder = event.get('$placeholder');
        var name = event.getIn(['event', 'name']);
        var age = event.getIn(['event', 'adults']) === 1 ? 'Adults' : event.getIn(['event', 'age']);
        var label = placeholder ? '' : name + ' ' + age;

        // FIXME(joshdmiller): use placeholder as template
        var onClick = placeholder ? undefined : function () {
          return selectEvent(event.get('event'));
        };

        var cell = _react2.default.createElement(
          _table.Cell,
          {
            row: rowCount,
            column: colCount,
            span: span,
            style: { textAlign: 'center' },
            onClick: onClick
          },
          _react2.default.createElement(
            'span',
            { className: 'label' },
            label
          )
        );

        colCount = colCount + span;

        return cell;
      }));
    });
  });

  return _react2.default.createElement(
    'div',
    {
      className: 'syllabus-chart-section',
      style: { marginBottom: 40 }
    },
    _react2.default.createElement(
      'div',
      {
        className: 'md-headline',
        style: _extends({
          marginBottom: 15
        }, styles.flexRow)
      },
      _react2.default.createElement(
        'span',
        null,
        chart.get('label')
      ),
      _react2.default.createElement('span', { style: _extends({}, styles.flex) }),
      _react2.default.createElement(
        'button',
        { onClick: addToChart, className: 'md-button md-icon-button' },
        _react2.default.createElement('i', { className: 'fa fa-plus' })
      )
    ),
    _react2.default.createElement(
      _table.Table,
      { columns: '150px repeat( ' + (numColumns - 1) + ', 1fr )' },
      cells
    )
  );
};

EventChart.propTypes = {
  chart: _react2.default.PropTypes.instanceOf(_immutable.Map),
  addToChart: _react2.default.PropTypes.func,
  selectEvent: _react2.default.PropTypes.func
};

var EventChartList = exports.EventChartList = function EventChartList(_ref2) {
  var _ref2$charts = _ref2.charts,
      charts = _ref2$charts === undefined ? (0, _immutable.List)() : _ref2$charts,
      _ref2$selectEvent = _ref2.selectEvent,
      selectEvent = _ref2$selectEvent === undefined ? function () {
    return null;
  } : _ref2$selectEvent,
      _ref2$addToChart = _ref2.addToChart,
      _addToChart = _ref2$addToChart === undefined ? function () {
    return null;
  } : _ref2$addToChart;

  return _react2.default.createElement(
    'div',
    null,
    charts.map(function (chart) {
      return _react2.default.createElement(EventChart, {
        selectEvent: selectEvent,
        addToChart: function addToChart() {
          return _addToChart(chart);
        },
        chart: chart
      });
    })
  );
};

EventChartList.propTypes = {
  charts: _react2.default.PropTypes.instanceOf(_immutable.List)
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/chart.js
// module id = 574
// module chunks = 0